import React, { useMemo } from 'react';
interface Star {
  x: number;
  y: number;
  size: number;
  opacity: number;
  delay: number;
}

/** Deterministic pseudo-random generator so the sky never reshuffles on re-render. */
function seeded(seed: number): () => number {
  let value = seed;
  return () => {
    value = (value * 1664525 + 1013904223) % 4294967296;
    return value / 4294967296;
  };
}
const CONSTELLATION = [{
  from: [18, 16],
  to: [27, 24]
}, {
  from: [27, 24],
  to: [38, 19]
}, {
  from: [38, 19],
  to: [46, 30]
}, {
  from: [68, 62],
  to: [77, 70]
}, {
  from: [77, 70],
  to: [86, 64]
}, {
  from: [12, 74],
  to: [22, 82]
}];
export function StarField() {
  const stars = useMemo<Star[]>(() => {
    const rand = seeded(20260908);
    return Array.from({
      length: 90
    }, () => ({
      x: rand() * 100,
      y: rand() * 100,
      size: rand() < 0.86 ? 1 : 2,
      opacity: 0.2 + rand() * 0.6,
      delay: rand() * 5
    }));
  }, []);
  return <div aria-hidden="true" className="pointer-events-none fixed inset-0 overflow-hidden" data-id="element-85" data-mp="3cac21i8u30qg">
      <div className="absolute inset-0 bg-ink" data-id="element-86" data-mp="i9c1o3lyec35" />

      {/* soft radial glows */}
      <div className="aura-pulse absolute -left-24 -top-32 h-[26rem] w-[26rem] rounded-full opacity-60" style={{
      background: 'radial-gradient(circle, rgba(109,40,217,0.34) 0%, rgba(5,6,15,0) 68%)'
    }} data-id="element-87" data-mp="n257kut5rqgt" />
      <div className="absolute -right-28 top-1/3 h-[24rem] w-[24rem] rounded-full opacity-50" style={{
      background: 'radial-gradient(circle, rgba(59,130,246,0.22) 0%, rgba(5,6,15,0) 70%)'
    }} data-id="element-88" data-mp="dbtt4ebulyvo" />
      <div className="absolute bottom-[-8rem] left-1/2 h-[22rem] w-[30rem] -translate-x-1/2 rounded-full opacity-40" style={{
      background: 'radial-gradient(ellipse, rgba(139,92,246,0.24) 0%, rgba(5,6,15,0) 72%)'
    }} data-id="element-89" data-mp="15xvb4mgqouwt" />

      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-90" data-mp="3cqfkb0ln5jus">
        {CONSTELLATION.map((line, i) => <line key={i} x1={line.from[0]} y1={line.from[1]} x2={line.to[0]} y2={line.to[1]} stroke="rgba(196,188,230,0.16)" strokeWidth="0.12" vectorEffect="non-scaling-stroke" data-id="element-91" data-mp="3hnp5u55wtbdc" data-mpi={i} />)}
      </svg>

      {stars.map((star, i) => <span key={i} className="twinkle absolute rounded-full bg-white" style={{
      left: `${star.x}%`,
      top: `${star.y}%`,
      width: star.size,
      height: star.size,
      opacity: star.opacity,
      animationDelay: `${star.delay}s`
    }} data-id="element-92" data-mp="19ioqvsynsmzh" data-mpi={i} />)}
    </div>;
}